import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 2,
	viewBox: "0 0 14 2",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.3333 0.75L1.66665 0.749999",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})
});
export default SvgDash;
